import { css } from 'lit';
import { property } from 'lit/decorators.js';
import { focusStyles } from '../css';
import { TmElement } from '../custom-element.helper';
import { Constructor } from './types';

const clickableElementStyles = css`
  :host {
    cursor: pointer;
  }

  :host(:focus-visible) {
    ${focusStyles};
  }
`;

export const ClickableMixin = <T extends Constructor<TmElement>>(
  superClass: T,
) => {
  class ClickableElement extends superClass {
    static styles = [
      (superClass as unknown as typeof TmElement).styles ?? [],
      clickableElementStyles,
    ];

    @property({ attribute: 'tabindex', reflect: true })
    override tabIndex = 1;

    override connectedCallback() {
      super.connectedCallback();
      this.#setupClickableMixin();
    }

    #setupClickableMixin = () => {
      this.listen('keydown', this.#handleClickableKeyboardEvent);
    };

    #handleClickableKeyboardEvent = (event: Event) => {
      const evt = event as KeyboardEvent;
      if (!['Enter', ' '].includes(evt.key)) return;
      event.preventDefault();
      this.click();
    };
  }

  // Cast return type to your mixin's interface intersected with the superClass type
  return ClickableElement as Constructor<TmElement> & T;
};
